import { ref } from "vue";

export const loginSuccess = ref(false)